import { Box, Skeleton } from "@mui/material";

const LessonPlanSkeleton = () => {
  return (
    <Box
      sx={{
        color: "text.primary",
        px: 0.25,
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          mb: 1.5,
        }}
      >
        <Skeleton
          variant="text"
          width="55%"
          height={28}
          sx={{ bgcolor: "background.paper" }}
        />
        <Box
          sx={{
            flex: "0 1 140px",
            minWidth: 24,
            borderTop: "1px dashed",
            borderColor: "divider",
            opacity: 0.9,
          }}
        />
        <Skeleton
          variant="rounded"
          width={24}
          height={24}
          sx={{
            borderRadius: 1,
            bgcolor: "background.paper"
          }}
        />
      </Box>

      <Box sx={{ mb: 3 }}>
        <Skeleton
          variant="text"
          width="100%"
          height={20}
          sx={{ bgcolor: "background.paper" }}
        />
        <Skeleton
          variant="text"
          width="94%"
          height={20}
          sx={{ bgcolor: "background.paper" }}
        />
        <Skeleton
          variant="text"
          width="82%"
          height={20}
          sx={{ bgcolor: "background.paper" }}
        />
      </Box>

      {[1, 2, 3].map((item) => (
        <Box key={item} sx={{
          width: "100%",
          mb: 1.5
        }}>
          <Box
            sx={{
              py: 1.5,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              borderBottom: "1px solid",
              borderColor: "background.paper"
            }}
          >
            <Skeleton
              variant="text"
              width={`${62 - item * 4}%`}
              height={22}
              sx={{ bgcolor: "background.paper" }}
            />
            <Skeleton
              variant="circular"
              width={20}
              height={20}
              sx={{ bgcolor: "background.paper" }}
            />
          </Box>
          <Box sx={{
            pt: 2,
            pb: 1,
            px: 1.5
          }}>
            <Skeleton
              variant="text"
              width="100%"
              height={18}
              sx={{ bgcolor: "background.paper" }}
            />
            <Skeleton
              variant="text"
              width="72%"
              height={18}
              sx={{ bgcolor: "background.paper" }}
            />
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export default LessonPlanSkeleton;
